import React from "react";
import { AppointmentPhase, Travellers } from "../../components";
import { newLineToBr } from "../../utilities";
import FileList from "../../flights/new/flightdetails/filelist";
import { PhosphorPencilButton } from "components/Atoms/PhosphorIconButton";
interface Props {
  train: server.dto.Train
  onTrainDetailsEditClicked: () => void
  onFilesAddClick: () => void
}

const TrainJourneyDetail = (props: Props) => {
  const { train } = props;
  return <table className="s1_table">
    <tbody>
      <tr>
        <td>{RESX.Status.resxStatus}</td>
        <td className="s1_cell_bigpadding flex">
          <div className="grow1">
            <AppointmentPhase value={train.phase} displayLabel />
          </div>
          {train.permissions.canModify && <PhosphorPencilButton
            layout="in-square"
            onClick={props.onTrainDetailsEditClicked} />}
        </td>
      </tr>

      {train.artist && <tr>
        <td>{RESX.Flight.Travellers}</td>
        <td className="s1_cell_bigpadding">
          <Travellers travellers={train.travellers} />
          <div className="s1_gray">{train.artist.name}</div>
        </td>
      </tr>}

      {(train.bookingCode || false) && <tr>
        <td>{RESX.Flight.BookingCode}</td>
        <td className="s1_cell_bigpadding">{train.bookingCode}</td>
      </tr>}

      {(train.travelAgency || false) && <tr>
        <td>{RESX.Flight.TravelAgency}</td>
        <td className="s1_cell_bigpadding">{train.travelAgency}</td>
      </tr>}

      {(train.notes || null) && <tr>
        <td>{RESX.Note.Notes}</td>
        <td className="s1_cell_bigpadding">{newLineToBr(train.notes)}</td>
      </tr>}

      <tr>
        <td>{RESX.File.Files}</td>
        <td className="s1_cell_bigpadding">
          <FileList
            files={train.files}
            onAddFilesClick={props.onFilesAddClick}
          />
        </td>
      </tr>
    </tbody>
  </table>;
};

export default TrainJourneyDetail;